const $inject = [];

const poiHighlightFilter = () => {
  function escapeRegexp(queryToEscape) {
    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
  }

  function highlight(matchItem, query) {
    return ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span' + ' class="ui-select-highlight">$&</span>');
  }

  function stripStopWords(text) {
    let tokens = text.split(' ');
    const stopwords = [
      'an',
      'and',
      'as',
      'at',
      'be',
      'by',
      'for',
      'has',
      'here',
      'if',
      'in',
      'is',
      'it',
      'my',
      'of',
      'on',
      'or',
      'that',
      'the',
      'their',
      'them',
      'then',
      'there',
      'these',
      'they',
      'this',
      'those',
      'to',
      'too',
      'up',
      'was',
      'way',
      'we',
      'were',
      'what',
      'where',
      'which',
      'while',
      'who',
      'with',
      'would',
      'you',
      'your',
      'a',
      'i',
    ];

    return tokens.filter((value) => stopwords.indexOf(value.toLowerCase()) === -1).join(' ');
  }

  return function (matchItem, query) {
    if (!query || !matchItem) {
      return matchItem;
    }

    let highlightedMatchItem = highlight(matchItem, query);

    if (highlightedMatchItem === matchItem) {
      query = stripStopWords(query);
      highlightedMatchItem = highlight(matchItem, query);
    }

    return highlightedMatchItem;
  };
};

export default poiHighlightFilter;



// WEBPACK FOOTER //
// ./src/components/lbPoiSelect/poiHighlightFilter.js